<micro-picklist title="Groups"
                [all]="all"
                [listMinSize]="listMinSize"
                [(selectedIds)]="selectedItems"
                (selectedIdsChange)="onNgModelChange($event)">
</micro-picklist>

